import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./http/index";
// import * as echarts from 'echarts'

import "./utils/setRem";
import "./assets/css/init.css";
import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);
Vue.prototype.$http = http; //放入全局
// Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
